import { addWeeks } from 'date-fns';
import { PreloadedQuery } from 'react-relay';

import { formatIsoLocalDateTime } from '@townsquare/date-utils/format';
import {
	getUtcEndOfWeekDate,
	parseProjectUpdatesFeedStartDate,
} from '@townsquare/date-utils/update';
import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';

import ProjectUpdatesViewQuery, {
	type ProjectUpdatesViewQuery as ProjectUpdatesViewQueryType,
} from '../ProjectUpdatesView/__generated__/ProjectUpdatesViewQuery.graphql';
import { getUpdateStateFilterFromQueryParams } from '../components/UpdateStateFilter';

export const projectUpdatesResource: RouteResource<
	PreloadedQuery<ProjectUpdatesViewQueryType, Record<string, unknown>>
> = createRelayResource<ProjectUpdatesViewQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;

		const utcStartDate = parseProjectUpdatesFeedStartDate(routerContext.query.start);
		const utcPrevDate = addWeeks(utcStartDate, -1);
		const utcEndDate = getUtcEndOfWeekDate(utcStartDate);

		return {
			query: ProjectUpdatesViewQuery,
			variables: {
				workspaceId: context.workspace?.globalId,
				prevDate: formatIsoLocalDateTime(utcPrevDate),
				startDate: formatIsoLocalDateTime(utcStartDate),
				endDate: formatIsoLocalDateTime(utcEndDate),
				stateFilter: getUpdateStateFilterFromQueryParams(routerContext.query.filter),
			},
			cacheKey: 'projectUpdates',
			options: {
				fetchPolicy: 'store-and-network' as const,
			},
		};
	},
});
